


















































































































































































































































































































































































































import ChoiceScoreSummaryChart from '@/views/ViewpointChoicesScorer/ChoiceScoreSummaryChart.vue';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import _ from 'lodash';
import Viewpoints from '@/store/modules/Viewpoints';
import Choices, { Choice } from '@/store/modules/Choices';
import StorageImage from '@/components/common/StorageImage.vue';
import ChoiceComparisonScoringGroup from '@/views/ViewpointChoicesScorer/ViewpointChoicesScorerRecursiveGroup.vue';
import Scoring from '@/store/modules/Scoring';
import Apps from '@/store/modules/Apps';
import Moveable from 'vue-moveable';
import Sticky from 'vue-sticky-directive';
import WorkspaceOptions from '@/store/modules/WorkspaceOptions';
import Modelling from '@/store/modules/Modelling';
import Decisions from '@/store/modules/Decisions';
import Colors from '@/utils/Colors';
import BasicInputForm from '@/components/forms/BasicInputForm.vue';
import UserAvatar from '@/components/common/UserAvatar.vue';
import CompareChoiceDialog from '@/views/ViewpointChoicesScorer/CompareChoiceDialog.vue';
import WorkspaceOptionValues from '@/utils/WorkspaceOptionValues';
import LinkShareDialog from '@/components/common/LinkShareDialog.vue';
import ThreadedCommentDisplay from "@/components/comments/ThreadedCommentDisplay.vue";
import { ResourceType } from '@/store/modules/Comments';
import ChoiceViewpointCommonMenu from '@/components/common/ChoiceViewpointCommonMenu.vue';
import Users from '@/store/modules/Users';
import ChoiceVisibilitySelectorMenu from '@/components/workspace-options/ChoicesVisibilitySelectorMenu.vue';
import ViewpointFactorScore from '@/components/scoring-input/ViewpointFactorScore.vue';
import { NotificationEventBus } from '@/EventBus';
import { Viewpoint } from '@/api/model/Viewpoint';
import AutocreateViewpointDialog from '@/components/common/AutocreateViewpointDialog.vue';
import CreateChoiceDialog from "@/views/ChoiceCards/CreateChoiceDialog.vue";

const viewpointModule = getModule(Viewpoints);
const decisionModule = getModule(Decisions);
const modellingModule = getModule(Modelling);
const choicesModule = getModule(Choices);
const scoringModule = getModule(Scoring);
const workspaceOptionsModule = getModule(WorkspaceOptions);
const appsModule = getModule(Apps);
const usersModule = getModule(Users);

@Component({
    name: 'ChoiceCompareRecursive',
    components: {
        BasicInputForm,
        ChoiceComparisonScoringGroup,
        StorageImage,
        Moveable,
        CompareChoiceDialog,
        UserAvatar,
        LinkShareDialog,
        ThreadedCommentDisplay,
        ChoiceViewpointCommonMenu,
        ChoiceVisibilitySelectorMenu,
        ViewpointFactorScore,
        AutocreateViewpointDialog,
        CreateChoiceDialog,
        ChoiceScoreSummaryChart,
        
    },
    directives: {
        Sticky,
    },
})
export default class ChoiceComparisonScoring extends Vue {
    @Prop({ default: false, type: Boolean })
    embed!: boolean;

    @Prop({ default: false, type: Boolean })
    appEmbed!: boolean;

    private selectionPath: string[] = [];
    private columnWidthInternal: any = {};
    private colors = Colors.COLORS;
    private createViewpointDialog = false;
    private createChoiceDialog = false;
    private creatingViewpoint = false;
    private limit = 1;
    private menu = false;
    private loading = false;
    private readonly widthOptions: any[] = WorkspaceOptionValues.WIDTH_OPTIONS;
    private showHover = ""
    private sortOptions: any[] = [
        {
            id: 1,
            name: 'Alphabetical',
        },
        {
            id: 2,
            name: `${this.singularChoiceLabel} - Low to High`,
        },
        {
            id: 3,
            name: `${this.singularChoiceLabel} - High to Low`,
        },
        {
            id: 4,
            name: `${this.singularFactorLabel} - Low to High`,
        },
        {
            id: 5,
            name: `${this.singularFactorLabel} - High to Low`,
        },
    ];

    private displayNumber: any[] = [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24];

    private moveable = {
        draggable: false,
        throttleDrag: 0,
        resizable: true,
        className: 'moveable',
        throttleResize: 1,
        renderDirections: ['w'],
        keepRatio: false,
        // dragArea: false,
        scalable: false,
        padding: {
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
        },
        throttleScale: 0,
        rotatable: false,
        throttleRotate: 0,
        pinchable: false, // ["draggable", "resizable", "scalable", "rotatable"]
        origin: false,
    };

    mounted() {
        // if(workspaceOptionsModule.choiceSort) {
        //     this.sortOrder = workspaceOptionsModule.choiceSort
        //     if(this.choiceScoresLoaded)
        //         this.sortChoiceList();
        // }

        if (!this.selectedViewpoint && this.viewpoints && this.viewpoints.length > 0 && !this.createViewpointDialog) {
            this.selectViewpoint(this.viewpoints[0].viewpointId);
            viewpointModule.setActiveViewpointId(this.viewpoints[0].viewpointId);
        }

        // TODO - Issues with loading viewpoints (Dion 2021-01-15)
        //
        // if (this.viewpoints) {
        //     this.viewpoints.forEach( (viewpoint: any) => {
        //         this.selectViewpoint(viewpoint.viewpointId);
        //         console.log(viewpoint.viewpointId);
        //     });
        // }
    }

    get numberOfChoices() {
        if (this.pagination <= this.displayChoiceIds.length) {
            return this.pagination;
        } else {
            return this.displayChoiceIds.length;
        }
    }

    get showCreateViewpointDialog() {
        return workspaceOptionsModule.showCreateViewpointDialog;
    }

    get viewpointSelectionMenu() {
        return appsModule.viewpointSelectionMenu;
    }

    get isOwnerOrAdmin() {
        return decisionModule.isAdminOrOwner;
    }
    
    get cardContainerSize() {
        let commentHeight = 0;
        if (this.commentVertical && this.pinnedRight) {
            commentHeight = this.commentBottomHeight;
        } else if (!this.pinnedRight && this.appEmbed) {
            commentHeight = 40;
        } else {
            commentHeight = 0;
        }
        if (this.appEmbed) {
            return `min-height: calc(100vh - 116px - ${commentHeight}px); max-height: calc(100vh - 116px - ${commentHeight}px);`;
        } else if (this.embed) {
             return `max-height : calc(100vh - 50px - ${commentHeight}px); min-height:calc(100vh - 50px - ${commentHeight}px)`;
        } else {
             return `max-height : calc(100vh - 198px - ${commentHeight}px); min-height:calc(100vh - 198px - ${commentHeight}px)`;
            //  return `max-height : calc(100%); min-height:calc(100%);display:flex`;
        }
    }

     get mainContainerSize() {
         let commentHeight = 0;
        if (this.commentVertical && this.pinnedRight ) {
            commentHeight = this.commentBottomHeight;
        } else if (!this.pinnedRight && this.appEmbed) {
            commentHeight = 40;
        } else {
            commentHeight = 0;
        }
        if(this.appEmbed){
            return `min-height: calc(100vh - 40px - ${commentHeight}px); max-height: calc(100vh- 40px - ${commentHeight}px);`;
        }else if(this.embed){
             return `max-height : calc(100vh - ${commentHeight}px); min-height:calc(100vh - ${commentHeight}px)`;
        }else{
             return `max-height : calc(100vh - 125px - ${commentHeight}px); min-height:calc(100vh - 125px - ${commentHeight}px)`;
        }
    }

    get commentBottomHeight(){
        return workspaceOptionsModule.commentBottomHeight;
    }

    get commentVertical() {
        return workspaceOptionsModule.commentVertical;
    }

    get pinnedRight() {
        return workspaceOptionsModule.pinnedRight;
    }

    get appMenuName(){
        return appsModule.activeAppMenuName;
    }

    get choicesList() {
        return _.cloneDeep(choicesModule.choicesList) || [];
    }

    get sortOrder() {
        // this.sortChoiceList();
        return workspaceOptionsModule.choiceSort;
    }

    set sortOrder(sortId: number) {
        workspaceOptionsModule.setChoiceSort(sortId);
    }

    // @Watch("sortOrder")
    // onChangeSortOrder(){
    //     console.log('sort');
    //     this.sortChoiceList();
    // }

    get pagination() {
        return workspaceOptionsModule.numOfCols;
    }

    get columnWidth() {
        return workspaceOptionsModule.choiceColumnWidth;
    }

    get choiceFirstCol() {
        return workspaceOptionsModule.choiceFirstCol;
    }
    set choiceFirstCol(width: number) {
        workspaceOptionsModule.setChoiceFirstCol(width);
    }
    get columnWidths() {
        if (Object.keys(workspaceOptionsModule.choicesColumnWidth).length === 0) {
            workspaceOptionsModule.changeChoiceColumnWidth(this.columnWidth);
        }
        return workspaceOptionsModule.choicesColumnWidth;
    }

    get activeViewpointId() {
        return viewpointModule.activeViewpointId || '';
    }

    get singularChoiceLabel() {
        return decisionModule.singularChoiceLabel;
    }

    get pluralChoiceLabel() {
        return decisionModule.pluralChoiceLabel;
    }

    get singularViewpointLabel() {
        return decisionModule.singularViewpointLabel;
    }

    get pluralViewpointLabel() {
        return decisionModule.pluralViewpointLabel;
    }

    get singularFactorLabel() {
        return decisionModule.singularFactorLabel;
    }

    get pluralFactorLabel() {
        return decisionModule.pluralFactorLabel;
    }

    set pagination(numOfCols: number) {
        workspaceOptionsModule.setNumOfCols(numOfCols);
    }

    set columnWidth(columnWidth: number) {
        workspaceOptionsModule.changeChoiceColumnWidth(columnWidth);
    }

    set activeViewpointId(viewpointId: string) {
        if (viewpointId) {
            viewpointModule.selectActiveViewpoint(viewpointId);
        }
    }

    private async selectActiveViewpoint(viewpointId: string | null = null) {
        if (viewpointId) {
            await this.selectViewpoint(viewpointId);
        }
        viewpointModule.selectActiveViewpoint(viewpointId);
        console.log(viewpointId);
    }

    private async selectViewpoint(viewpointId: string) {
        if (viewpointId && viewpointId !== 'ROOT') {
            await viewpointModule.selectViewpoint(viewpointId);
            console.log(viewpointId);
        }
    }

    get selectedViewpoints() {
        return viewpointModule.selectedViewpoints;
    }

    get selectedViewpoint() {
        if (viewpointModule.activeViewpointId && viewpointModule.decisionViewpointsMap) {
            return viewpointModule.decisionViewpointsMap[viewpointModule.activeViewpointId];
        }
    }

    set selectedViewpoint(selectedViewpoint: any) {
        if (selectedViewpoint) {
            this.selectViewpoint(selectedViewpoint.viewpointId);
            viewpointModule.setActiveViewpointId(selectedViewpoint.viewpointId);
        } else {
            viewpointModule.setActiveViewpointId(null);
        }
    }

    get selectedDecision() {
        return decisionModule.selectedDecision;
    }

    get viewpoints() {
        if (viewpointModule.decisionViewpoints) {
            if (this.isOwnerOrAdmin) {
                let decisionViewpoints = _.cloneDeep(viewpointModule.decisionViewpoints);
                return decisionViewpoints.sort((a: any, b: any) => {
                    if (a.name === b.name) return 1;
                    if (a.name){
                        return a.name.localeCompare(b.name);
                    }else{
                        return -1;
                    }
                });
            } else {
                let publicViewpoints = 
                _.cloneDeep(viewpointModule.decisionViewpoints.filter(x => x.visibility === 'PUBLIC'));
                let createdViewpoints = 
                _.cloneDeep(viewpointModule.decisionViewpoints.filter(x => x.ownerUserId === this.currentUserId));
                let userViewpoints = publicViewpoints.concat(createdViewpoints);
                if (userViewpoints && userViewpoints.length > 0) {
                    return userViewpoints.sort((a: any, b: any) => {
                        if (a.name === b.name) return 1;
                        if (a.name){
                            return a.name.localeCompare(b.name);
                        }else{
                            return -1;
                        }
                    });
                } else {
                    return userViewpoints;
                }
            }
        }
        // if (viewpointModule.decisionViewpoints) {
        //     return viewpointModule.decisionViewpoints.sort((a: any, b: any) => {
        //         if (a.name === b.name) return 1;
        //         return a.name.localeCompare(b.name);
        //     });
        // }
        return undefined;
    }

    get currentUserId() {
        return usersModule.currentUserProfile.userId;
    }

    get viewpointsList() {
        return _.sortBy(viewpointModule.decisionViewpoints || [], 'name');
    }

    get choiceIds() {
        return this.sortedChoiceList.map((choice: any) => choice.id);
    }

    get choices() {
        return choicesModule.choices;
    }

    get choiceScores() {
        return scoringModule.viewpointScores;
    }

    get selectedChoice() {
        return choicesModule.selectedChoiceId
    }

    get factors() {
        return modellingModule.publishedModelFactorResources;
    }

    get numberOfVisibleChoices() {
        return this.choiceIds.filter((id: any) => this.choiceVisibility[id]).length;
    }
    // Get pagination choices, pagination index starts at 1 bring down to 0
    get displayChoiceIds() {
        return this.choiceIds
            .filter((id: any) => this.choiceVisibility[id])
            .slice(this.limit - 1, this.limit + this.pagination - 1);
    }

    // Need to ensure all the choice scores is available for the choices
    get choiceScoresLoaded() {
        if (
            !this.choiceScores ||
            !this.selectedViewpoint ||
            !this.choiceScores[this.selectedViewpoint.viewpointId]
        ) {
            return false;
        }
        for (let index in this.choiceIds) {
            let cId = this.choiceIds[index];
            if (!this.choiceScores[this.selectedViewpoint.viewpointId].choiceScores[cId]) {
                return false;
            }
        }
        return true;
    }

    get choiceVisibility() {
        return workspaceOptionsModule.choiceVisibility;
    }

    get startingFactors() {
        if (workspaceOptionsModule.trimTopGroups) {
            let topFactor = 'M';
            return this.getTopGroup('M');
        } else {
            return ['M'];
        }
    }

    get resource() {
        if (this.activeViewpointId) {
            return {
                name: this.selectedViewpoint.name,
                id: this.activeViewpointId,
                type: ResourceType.VIEWPOINT
            }
        }
    }

    get selectedViewpointIds(){
        return viewpointModule.selectedViewpointIds
    }

    private getSecondaryResource(choiceId) {
        if (getModule(Choices).choices[choiceId]) {
            return {
                id: choiceId,
                type: ResourceType.CHOICE,
                name: getModule(Choices).choices[choiceId].name
            }
        }
    }

    get tertiaryResource() {
        return {
            id: "THREAD",
            type: ResourceType.FACTOR,
            name: "THREAD"
        }
    }

    private getTopGroup(topId: string) {
        if (
            this.factors[topId].childrenIds.length != 1
                ? true
                : 'groupTypeDefinition' in this.factors[this.factors[topId].childrenIds[0]] || this.factors[this.factors[topId].childrenIds[0]].type != 'FACTOR_GROUP'
        ) {
            return this.factors[topId].childrenIds;
        }

        if (this.factors[topId].childrenIds.length === 1) {
            return this.getTopGroup(this.factors[topId].childrenIds[0]);
        }
    }

    private selectBreadcrumbItem(id: string) {
        workspaceOptionsModule.selectBreadcrumbItem(id);
    }

    get sortedChoiceList() {
        switch (this.sortOrder) {
            case 1: {
                return this.choicesList.sort((a: any, b: any) => {
                    if (a.name === null || a.name === undefined) a.name = '';
                    if (b.name === null || b.name === undefined) b.name = '';
                    return a.name.localeCompare(b.name);
                });
                break;
            }

            case 2: {
                return this.choicesList.sort((a: any, b: any) => {
                    if (this.selectedViewpoint)
                        a.rank = this.choiceScores[this.selectedViewpoint.viewpointId].choiceScores[
                            a.id
                        ].rank;
                    if (this.selectedViewpoint)
                        b.rank = this.choiceScores[this.selectedViewpoint.viewpointId].choiceScores[
                            b.id
                        ].rank;
                    return a.rank < b.rank ? 1 : a.rank > b.rank ? -1 : 0;
                });
                break;
            }
            case 3: {
                return this.choicesList.sort((a: any, b: any) => {
                    if (this.selectedViewpoint)
                        a.rank = this.choiceScores[this.selectedViewpoint.viewpointId].choiceScores[
                            a.id
                        ].rank;
                    if (this.selectedViewpoint)
                        b.rank = this.choiceScores[this.selectedViewpoint.viewpointId].choiceScores[
                            b.id
                        ].rank;
                    return a.rank < b.rank ? -1 : a.rank > b.rank ? 1 : 0;
                });
                break;
            }

            case 4: {
                let selectedFactorId = workspaceOptionsModule.selectedPathItemId
                    ? workspaceOptionsModule.selectedPathItemId
                    : 'M';
                return this.choicesList.sort((a: any, b: any) => {
                    if (this.selectedViewpoint)
                        a.score = this.choiceScores[this.selectedViewpoint.viewpointId]
                            .choiceScores[a.id].choiceFactorScores[selectedFactorId]
                            ? this.choiceScores[this.selectedViewpoint.viewpointId].choiceScores[
                                  a.id
                              ].choiceFactorScores[selectedFactorId].score
                            : 0;
                    if (this.selectedViewpoint)
                        b.score = this.choiceScores[this.selectedViewpoint.viewpointId]
                            .choiceScores[b.id].choiceFactorScores[selectedFactorId]
                            ? this.choiceScores[this.selectedViewpoint.viewpointId].choiceScores[
                                  b.id
                              ].choiceFactorScores[selectedFactorId].score
                            : 0;
                    return a.score < b.score ? -1 : a.score > b.score ? 1 : 0;
                });

                break;
            }

            case 5: {
                let selectedFactorId = workspaceOptionsModule.selectedPathItemId
                    ? workspaceOptionsModule.selectedPathItemId
                    : 'M';
                return this.choicesList.sort((a: any, b: any) => {
                    if (this.selectedViewpoint)
                        a.score = this.choiceScores[this.selectedViewpoint.viewpointId]
                            .choiceScores[a.id].choiceFactorScores[selectedFactorId]
                            ? this.choiceScores[this.selectedViewpoint.viewpointId].choiceScores[
                                  a.id
                              ].choiceFactorScores[selectedFactorId].score
                            : 0;
                    if (this.selectedViewpoint)
                        b.score = this.choiceScores[this.selectedViewpoint.viewpointId]
                            .choiceScores[b.id].choiceFactorScores[selectedFactorId]
                            ? this.choiceScores[this.selectedViewpoint.viewpointId].choiceScores[
                                  b.id
                              ].choiceFactorScores[selectedFactorId].score
                            : 0;
                    return a.score < b.score ? 1 : a.score > b.score ? -1 : 0;
                });

                break;
            }
        }
    }

    private skipLeft() {
        this.limit -= this.pagination;
        if (this.limit <= 0) {
            this.limit = 1;
        }
    }

    private skipRight() {
        this.limit += this.pagination;
        if (this.limit > this.numberOfVisibleChoices - this.pagination + 1) {
            this.limit = this.numberOfVisibleChoices - this.pagination + 1;
        }
    }

    private async createViewpoint(payload: any) {
        if (!this.selectedDecision) return;
        this.creatingViewpoint = true;
         NotificationEventBus.emitProcessingMessage();
        let newViewpoint = {
            viewpointId: '',
        };
        try {
            if (!this.selectedDecision) return;
            let newVp = {
                decisionId: this.selectedDecision.decisionId,
                name: payload.name,
                description: payload.description,
                addToList: true
            }
            newViewpoint =  await decisionModule.createDecisionViewpoint(newVp);
            if(newViewpoint?.viewpointId != '' && workspaceOptionsModule.activeViewpointLists.length > 0) {
                decisionModule.addViewpointToActiveLists(newViewpoint.viewpointId)
            }
            
            NotificationEventBus.emitSuccessMessage()
        } catch (err) {
            NotificationEventBus.emitFailedMessage(err)
        }
        this.createViewpointDialog = false;
        this.creatingViewpoint = false;
    }

    private async editAutocreateViewpoint(payload: Viewpoint) {
        await viewpointModule.selectActiveViewpoint(payload.viewpointId);
        this.createViewpointDialog = false;
    }

    private async deleteViewpoint(){
        console.log('select viewpoint');
    }

    private selectChoice(choiceId: string) {
        choicesModule.selectChoice(choiceId)
    }

    private async createChoice(name: string) {
        let choice: Choice = {
            name: name,
            image: null,
            lastUpdatedTimestamp: null,
            creationTimestamp: null,
            visibility: 'ALL',
            ownerUserId: this.currentUserId
        }
        let newChoice = await choicesModule.createChoice(choice);
        this.createChoiceDialog = false;
        if(workspaceOptionsModule.activeChoiceLists.length > 0) {
            await decisionModule.addChoiceToActiveLists(newChoice.id)
            await decisionModule.getDecisionLists();
        }
        await choicesModule.fetchChoices();
        choicesModule.selectChoice(newChoice.id);
    }

    private editChoice(choice: Choice) {
        choicesModule.selectChoice(choice.id)
        this.createChoiceDialog = false;
    }
}
